module.exports = __WEBPACK_EXTERNAL_MODULE_104__;


//////////////////
// WEBPACK FOOTER
// external "element-ui/lib/message-box"
// module id = 104
// module chunks = 0 2